import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import React from "react";

export const InputDropdownField = ({ label, options, ...props }: any) => {
    const generateSingleOption = (option: any) => {
        return (
            <MenuItem key={option.value} value={option.value}>
                {option.label}
            </MenuItem>
        );
    }
    return (
        <FormControl fullWidth>
            <InputLabel>{label}</InputLabel>
            <Select {...props}>
                {options.map((option: any) => (
                    generateSingleOption(option)
                ))}
            </Select>
        </FormControl>
    );
}
